import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Login from "./Login";
import FilterOptions from "./FilterOptions";
import { PhotoPreviewContent, AddCredentialForm, AddPaymentMethodForm, ApplyFundingForm, DeleteConfirmationForm } from "./Forms";
import RequestKitchen from "./RequestKitchen";
import CompleteStepSuccess from "../../components/Desktop/CompleteStepSuccess";
import AddBusiness from "./AddBusiness";

import  OrderInventoryForm from "./OrderInventoryForm";
import RegisterTrainingForm  from './RegisterTrainingForm'
import ObtainDocumentationForm from './ObtainDocumentationForm'
import ChatWindow from "./chatWindow";
import UserListWindow from "./chatUsers";

import { ReactComponent as ArrowLeft } from "../../icons/LeftArrow.svg";
import { ReactComponent as CheckMarkIcon } from "../../icons/CheckMarkIcon.svg";
import { ReactComponent as CommunityIcon } from "../../icons/Community.svg";
import { ReactComponent as ChatbotInverted } from "../../icons/ChatbotInverted.svg";
import { ReactComponent as StaffIconInverted } from "../../icons/StaffIconInverted.svg";
// import { ReactComponent as KitchenIcon } from "../../icons/KitchenIcon.svg";
import { ReactComponent as NavResourcesIconDark } from '../../icons/NavResourcesIconDark.svg';
import { ReactComponent as InventoryIcon } from "../../icons/InventoryIcon.svg";

import { FilterType, CredentialSchema, CurrentRequirementsSchema, ResourceSchema, ResourceType, ResourceBookingSchema, MembershipStatusType, BusinessFormData, MyBusinessSchema,ResourcePlanSchema, MembershipSchema, CommunitySchema, SettingsOptionsType, SearchFilterOptionType, InventorySchema, PlanSchema } from "../../data/types";
import { useCompleteSignIn, useLoadAccountMemberships, useLoadMember } from "../../hooks/authhooks";
import ScheduleExpertForm from "./ScheduleExpertForm";
import RequestMembershipForm from "./RequestMembershipForm";
import InlineStatusSkeleton from "../../components/InlineStatusSkeleton";
import { InviteModalContent } from "../../components/Desktop/InviteModalContent";
import { styleThousandCommas, capitalizeString, getPeriodStyles, planRecurrenceMap, getDirectLinkFromGoogleDriveSharedLink, buildInventoryItemsById, getInventorySelectionLabel, planHasDisplayFeatures } from "../../utils/helpers";
import GenAIView from "../../components/Desktop/GenAILoadingView";
import BookingDetailsView from './BookingDetailsForm';
import { ArrowBack, Cancel, Close, Check } from "@mui/icons-material";
import SubmittedAgreementPreview from "../SubmittedAgreementPreview";
import ResourceCard from "../../components/Desktop/ResourceCard";
import { useLoadResourceOptions, useLoadResources } from "../../hooks/apphooks";
import CommunityAvatar from "../../components/CommunityAvatar";
// Inline SVG Icons (most reliable)
// import { FacebookIcon, XIcon, InstagramIcon } from "../components/Desktop/SocialIcons";

// import { ReactComponent as CopyIcon } from "../icons/CopyIcon.svg";


type MembershipAgreementSignedModalProps = {
  isOpen: boolean;
  closeAppModal: () => void;
  newMembership: MembershipSchema;
  setIsShowingAgreement: React.Dispatch<React.SetStateAction<boolean>>;
  setIsShowingSignedAgreementSuccessModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const MembershipAgreementSignedModal: React.FC<MembershipAgreementSignedModalProps> = (props) => {
  var { newMembership, isOpen,setIsShowingSignedAgreementSuccessModal, setIsShowingAgreement, closeAppModal } = props

  return (
    <div className={`fixed inset-0 z-50 flex items-start justify-center py-4`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => closeAppModal()}></div>
      <dialog
        data-testid="add-plan-modal"
        className="z-50 w-full max-w-lg md:max-w-xl  bg-[#fff] relative rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] overflow-hidden flex flex-col"
        open={isOpen}
        onClose={() => closeAppModal()}
        style={{ margin: 0 }}
      >
          {/* <div className="overflow-y-auto max-h-[100vh] flex-1 pb-4"> */}
              <div className="bg-white rounded-2xl shadow-xl max-w-auto p-6 sm:p-8 flex flex-col items-center text-center">
                <div className="flex items-center justify-center w-8 h-8 rounded-full border-0 bg-primaryDark-300 mb-4">
                  <Check className="text-white" style={{ fontSize: 24 }} />
                </div>
                <p className="text-primaryDark-200 text-center font-medium font-raleway text-[14px] sm:text-[14px] leading-relaxed mb-3">
                  Agreement signed successfully. A copy has been emailed to you.
                </p>
                <SubmittedAgreementPreview
                  fileUrl={newMembership.member_agreement?.file_url}
                  variant="desktop"
                />
                <div className="flex flex-col gap-3 w-full">
                  <a
                    href={newMembership.member_agreement?.file_url ?? "#"}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full py-3 px-4 rounded-lg font-semibold font-raleway text-[16px] text-white bg-primaryDark-200 hover:bg-primaryDark-300 transition-colors"
                  >
                    Download Copy
                  </a>
                  <button
                    type="button"
                    onClick={() => {
                      setIsShowingSignedAgreementSuccessModal(false);
                      setIsShowingAgreement(false);
                    }}
                    className="w-full py-3 px-4 rounded-lg font-semibold font-raleway text-[16px] text-primaryDark-200 bg-white border-1 border-[#E9E9E9] hover:bg-[#E9E9E9] transition-colors"
                  >
                    Back to Checklist
                  </button>
                </div>
              </div>
          {/* </div> */}
      </dialog>
    </div>
  );
}

type PhotoPreviewModalProps = {
  isOpen: boolean
  photos: string[]
  currentIndex: number
  resourceName: string
  onClose: () => void
  onNavigate: (index: number) => void
}

export const PhotoPreviewModal: React.FC<PhotoPreviewModalProps> = ({ isOpen, photos, currentIndex, resourceName, onClose, onNavigate }) => {
  const getPhotoUrl = (photo: string) => {
    return getDirectLinkFromGoogleDriveSharedLink(photo) || ''
  }

  const validPhotos = photos && photos.length > 0 ? photos.filter(p => getPhotoUrl(p)) : []
  // const currentPhoto = validPhotos[currentIndex]
  // const currentPhotoUrl = currentPhoto ? getPhotoUrl(currentPhoto) : ''

  useEffect(() => {
    if (!isOpen || validPhotos.length === 0) return

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'ArrowLeft') {
        const newIndex = currentIndex > 0 ? currentIndex - 1 : validPhotos.length - 1
        onNavigate(newIndex)
      }
      if (e.key === 'ArrowRight') {
        const newIndex = currentIndex < validPhotos.length - 1 ? currentIndex + 1 : 0
        onNavigate(newIndex)
      }
      if (e.key === 'Escape') {
        onClose()
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [isOpen, currentIndex, validPhotos.length, onNavigate, onClose])

  if (!isOpen || validPhotos.length === 0) return null

  return (
    <div className={`fixed inset-0 z-[999] ${isOpen ? 'flex' : 'hidden'} items-center justify-center`}>
      <div className='fixed inset-0 bg-black/90 z-40' onClick={onClose}></div>
      
      <div 
        className='relative z-50 w-full h-full flex items-center justify-center p-4'
        onClick={(e) => {
          // Close modal when clicking outside the PhotoPreviewContent area
          if (e.target === e.currentTarget) {
            onClose()
          }
        }}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className='absolute top-4 right-4 text-white hover:text-gray-300 z-50 bg-black/50 rounded-full p-2'
        >
          <Close style={{ fontSize: 28 }} />
        </button>

        <PhotoPreviewContent isOpen={isOpen} photos={validPhotos} currentIndex={currentIndex} resourceName={resourceName} onClose={onClose} onNavigate={onNavigate} />
      </div>
    </div>
  )
}

type DeleteConfirmationModalProps =  {
  isOpen: boolean;
  // loggedinUid: string
  // setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  closeDeleteModal: () => void;
  handleDelete: (dataId: string) => void
  dataName: string
  data: any;
};

export const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = (props) => {
  let { isOpen, data, dataName, closeDeleteModal, handleDelete } = props;
  return (

    <div className={`fixed inset-0 z-50 ${isOpen ? "flex" : "hidden"} items-start justify-center p-6`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => closeDeleteModal()}></div>
      <dialog
        data-testid="invite-modal"
        className="z-50 w-full max-w-lg top-16 md:max-w-2xl max-h-[95vh] bg-[#fff] relative rounded-2xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] overflow-hidden flex flex-col"
        open={isOpen}
        onClose={() => closeDeleteModal()}
        style={{ margin: 0 }}
      >
        <div className="overflow-y-auto flex-1 p-4">
          <span onClick={closeDeleteModal} className="ml-auto w-full flex cursor-pointer">
              <Cancel className="text-[#A1A1A1] hover:text-[#777] h-[18px] w-[18px] ml-auto" />
          </span>
          <div className="w-full mx-auto">
            <DeleteConfirmationForm
              data={data}
              dataName={dataName}
              handleClose={() => closeDeleteModal()}
              handleDelete={handleDelete}
            />
          </div>
        </div>
      </dialog>
    </div>
  );
};

type AddPaymentMethodModalProps = {
  isOpen: boolean;
  loggedinUid: string
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const AddPaymentMethodModal: React.FC<AddPaymentMethodModalProps> = (props) => {
  var { loggedinUid, isOpen, setIsOpen } = props;
  // const { user } = useCompleteSignIn();
  // const loggedinUid = user && user?.uid ? user.uid : "";
  // const [isAddingPayMethod, setIsAddingPayMethod] = useState<boolean>(false);

  const closeAppModal = () => {
    setIsOpen(false);
  };

  return (
    <div className={`fixed inset-0 z-50 ${isOpen ? "flex" : "hidden"} items-start justify-center p-6`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => closeAppModal()}></div>
      <dialog
        data-testid="invite-modal"
        className="z-50 w-10/12 sm:w-5/12 h-auto top-16 bg-[#fff] relative rounded-2xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] overflow-hidden flex flex-col"
        open={isOpen}
        onClose={() => closeAppModal()}
        style={{ margin: 0 }}
      >
        <div className="flex flex-row justify-end p-4">
            <span onClick={() => closeAppModal()} className="ml-auto w-full flex cursor-pointer">
              <Cancel className="text-[#A1A1A1] hover:text-[#777] h-[18px] w-[18px] ml-auto" />
            </span>
        </div>
        <div className="flex flex-col items-center justify-center w-11/12 m-auto p-4">
          <AddPaymentMethodForm loggedinUid={loggedinUid} isAddingPayMethod={isOpen} setIsAddingPayMethod={setIsOpen} handleClose={closeAppModal} />
        </div>
      </dialog>
    </div>
  );
};


type InviteModalProps = {
  uid: string;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  closeAppModal: () => void;
}


export const InviteModal: React.FC<InviteModalProps> = (props) => {
  var { isOpen, closeAppModal, uid } = props;

  return (
    <div className={`fixed inset-0 z-50 ${isOpen ? "flex" : "hidden"} items-start justify-center p-6`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => closeAppModal()}></div>
      <dialog
        data-testid="invite-modal"
        className="z-50 w-full max-w-lg md:max-w-2xl max-h-[95vh] bg-[#fff] relative rounded-2xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] overflow-hidden flex flex-col"
        open={isOpen}
        onClose={() => closeAppModal()}
        style={{ margin: 0 }}
      >

          <div className="flex flex-row justify-end p-4">
            <span onClick={() => closeAppModal()} className="ml-auto w-full flex cursor-pointer">
              <Cancel className="text-[#A1A1A1] hover:text-[#777] h-[18px] w-[18px] ml-auto" />
            </span>
          </div>
          <div className="flex flex-col items-center justify-center my-4">
            <InviteModalContent uid={uid} />
          </div>
        </dialog>
    </div>
  );
}



// const InviteModalContent: React.FC = () => {
//   return (
//     <div className="p-6 overflow-y-auto flex-1">
//       <div className="flex flex-col items-center justify-start space-y-6">
//         <div className="text-center">
//           <h1 className="text-2xl font-bold text-gray-900 mb-2">Invite a Friend</h1>
//           <p className="text-gray-600">Invite a friend to join HomeCook and earn $100 for each successful referral.</p>
//         </div>
//       </div>
//     </div>
//   );
// }


interface BookingDetailsModalProps {
  booking: ResourceBookingSchema | null;
  isOpen: boolean;
  isEditMode: boolean;
  onClose: () => void;
  onSave: (communityId: string, bookingId: string, changedAttributes: ResourceBookingSchema) => void;
  onCancel: (communityId: string, resourceId: string, bookingId: string) => void;
  userBookings?: ResourceBookingSchema[];
  searchFilterOptions?: SearchFilterOptionType;
}


export const BookingDetailsModal: React.FC<BookingDetailsModalProps> = ({
  booking,
  isOpen,
  isEditMode,
  onClose,
  onSave,
  onCancel,
  userBookings,
  searchFilterOptions,
}) => {
  return (
    // <div className={`inset-0 ${isOpen ? "block" : "hidden"}`}>
    <div className={`fixed inset-0 z-50 ${isOpen ? "flex" : "hidden"} items-center justify-center`}>
    <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => onClose()}></div>

      <dialog
        data-testid="view-login-modal"
        className="z-50 my-auto sm:w-[600px] h-auto max-h-[97vh] overflow-y-auto bg-[#fff] p-4 rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)]"
        open={isOpen}
        onClose={() => onClose()}
      >
        <BookingDetailsView userBookings={userBookings} booking={booking} isOpen={isOpen} isEditMode={isEditMode} onClose={onClose} onSave={onSave} onCancel={onCancel} searchFilterOptions={searchFilterOptions} />
      </dialog>
    </div>
  )
}


type MorePlanDetailsModalProps = {
  isOpen: boolean;
  plan_details: ResourcePlanSchema;
  resourceDetail?: ResourceSchema;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  closeAppModal: () => void;
};

export const MorePlanDetailsModal: React.FC<MorePlanDetailsModalProps> = (props) => {
  var { isOpen, closeAppModal, plan_details, resourceDetail } = props;

  return (
    // <div className={`inset-0 ${isOpen ? "block" : "hidden"}`}>
    <div className={`fixed inset-0 z-50 ${isOpen ? "flex" : "hidden"} items-center justify-center`}>
    <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => closeAppModal()}></div>

      <dialog
        data-testid="view-login-modal"
        className="z-50 my-auto sm:w-[600px] h-auto bg-[#fff] p-4 rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)]"
        open={isOpen}
        onClose={() => closeAppModal()}
      >

        <MorePlanDetailsModalContent plan_details={plan_details} resourceDetail={resourceDetail} closeAppModal={closeAppModal} />

      </dialog>
    </div>
  );
};



// ViewPlanDetailsModal Component
type ViewPlanDetailsModalProps = {
  isOpen: boolean;
  onClose: () => void;
  plan: ResourcePlanSchema | undefined;
  resourceDetail?: ResourceSchema;
  onContinue: () => void;
};

export const ViewPlanDetailsModal: React.FC<ViewPlanDetailsModalProps> = ({ isOpen, onClose, plan, resourceDetail, onContinue }) => {
  if (!isOpen || !plan) return null;

  return (
    <div className={`fixed inset-0 z-50 ${isOpen ? "flex" : "hidden"} items-center justify-center`}>
    <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => onClose()}></div>

      <dialog
        data-testid="view-plan-details-modal"
        className="z-50 my-auto sm:w-[600px] h-auto top-10 overflow-y-auto bg-[#fff] p-4 rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)]"
        open={isOpen}
        onClose={() => onClose()}
      >
        <div className="flex flex-col p-2">
            <span onClick={() => onClose()} className="w-full flex cursor-pointer text-gray-500 font-semibold text-[14px] font-raleway my-auto justify-start mb-2">
              {/* <button onClick={()=> onClose()} className={`flex w-full justify-start border-0 cursor-pointer text-gray-500 font-semibold text-[14px] font-raleway `}> */}
                <ArrowBack className="mr-2 my-auto" /> Back
              {/* </button> */}
            </span>
            <ViewPlanDetailsForms plan={plan} resourceDetail={resourceDetail} />
          </div>
        
      </dialog>
    </div>
  );
};

type PlanFeaturesListProps = {
  plan: ResourcePlanSchema;
  resourceDetail?: ResourceSchema;
  emptyMessage?: string;
};

/** Renders plan perks plus linked resources and bundled inventory under Plan Features */
const PlanFeaturesList: React.FC<PlanFeaturesListProps> = ({ plan, resourceDetail, emptyMessage }) => {
  const inventoryItemsById = useMemo(
    () => buildInventoryItemsById(resourceDetail),
    [resourceDetail]
  );
  const hasDisplayFeatures = planHasDisplayFeatures(plan.features, plan.associated_resources);

  if (!hasDisplayFeatures) {
    return emptyMessage ? (
      <span className='text-black/50 font-open-sans text-[16px]'>{emptyMessage}</span>
    ) : null;
  }

  return (
    <div className='space-y-2'>
      {plan.features?.map((feature: string, index: number) => (
        <div key={`feature-${index}`} className='flex items-center'>
          <div className='w-4 h-4 bg-primaryDark-300 rounded-full flex items-center justify-center mr-3 shrink-0'>
            <CheckMarkIcon className='w-3 h-3 text-white' />
          </div>
          <span className='text-black font-open-sans text-[16px]'>{feature}</span>
        </div>
      ))}
      {plan.associated_resources?.map((association, associationIndex) => (
        <div key={`assoc-${association.resource_id || associationIndex}`} className='space-y-2'>
          {(association.resource_name || association.resource_id) && (
            <div className='flex items-center'>
              <div className='w-4 h-4 rounded-full bg-primaryDark-400/10 flex items-center justify-center mr-3 shrink-0'>
                <NavResourcesIconDark className='w-2.5 h-2.5 text-primaryDark-300' aria-hidden />
              </div>
              <span className='text-black font-open-sans text-[16px] truncate'>
                {association.resource_name || 'Linked resource'}
              </span>
            </div>
          )}
          {association.inventory?.map((selection, inventoryIndex) => (
            <div
              key={`inventory-${associationIndex}-${selection.inventory_id}-${inventoryIndex}`}
              className={`flex items-center ${(association.resource_name || association.resource_id) ? 'ml-5' : ''}`}
            >
              <div className='w-4 h-4 rounded-full bg-primaryDark-400/10 flex items-center justify-center mr-3 shrink-0'>
                <InventoryIcon className='w-2.5 h-2.5 text-primaryDark-300' aria-hidden />
              </div>
              <span className='text-black font-open-sans text-[16px] truncate'>
                {getInventorySelectionLabel(selection, inventoryItemsById)}
              </span>
              {selection.max_qty > 0 && (
                <span className='text-[#808080] text-[13px] ml-1 shrink-0'>
                  · max {selection.max_qty}
                </span>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

type ViewPlanDetailsFormsProps = {
  plan: ResourcePlanSchema;
  resourceDetail?: ResourceSchema;
}

const ViewPlanDetailsForms: React.FC<ViewPlanDetailsFormsProps> = (props) => {
  var { plan, resourceDetail } = props;
  const standardPeriodStyles = getPeriodStyles('STANDARD')
  const offPeakPeriodStyles = getPeriodStyles('OFF_PEAK')
  const peakPeriodStyles = getPeriodStyles('PEAK')

  return (
    <>

        <div className="mb-6">
          <h2 className="text-[18px] font-raleway font-bold text-black mb-2">Booking Plan Details</h2>
          <p className="text-[#4D4D4D] text-[16px] font-open-sans">See what's included before you choose.</p>
        </div>

        {/* Plan Name */}
        <div className="mb-4 bg-[#FAFAFA] rounded-lg p-3">
          <label className="block text-[#808080]/50 font-medium text-[14px] font-raleway mb-2">Plan Name</label>
          <div>
            <p className="text-black font-open-sans text-[16px]">{plan.plan_name}</p>
          </div>
        </div>

        {/* Plan Description */}
        <div className="mb-6 bg-[#FAFAFA] rounded-lg p-3">
          <label className="block text-[#808080]/50 font-medium text-[14px] font-raleway mb-2">Plan Description</label>
          <div>
            <p className="text-black font-open-sans text-[16px]">{plan.plan_description || "No description available"}</p>
          </div>
        </div>

        {/* Key Metrics Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
          {/* Standard Rate */}
          <div className="border-0 bg-[#FAFAFA] rounded-lg p-4 shadow-sm">
            <div className="flex items-center mb-2">
              <div className={`w-2 h-2 ${standardPeriodStyles.dot} rounded-full mr-2`}></div>
              <span className="text-[#808080]/50 font-medium text-[14px] font-raleway">Standard Rate</span>
            </div>
            <p className="text-[18px] font-semibold font-raleway text-black">${plan.plan_rate ? styleThousandCommas(plan.plan_rate) : '10'} / {planRecurrenceMap[plan?.plan_recurrence as keyof typeof planRecurrenceMap]}</p>
          </div>

          {/* Off-Peak Rate */}
          {(plan?.plan_recurrence === "hourly" || plan?.plan_recurrence === "daily") && plan?.pricing_type === "dynamic" ? (<div className="border-0 bg-[#FAFAFA] rounded-lg p-4 shadow-sm">
            <div className="flex items-center mb-2">
              <div className={`w-2 h-2 ${offPeakPeriodStyles.dot} rounded-full mr-2`}></div>
              <span className="text-[#808080]/50 font-medium text-[14px] font-raleway">Off-Peak Rate</span>
            </div>
            <p className="text-[18px] font-semibold font-raleway text-black">${plan.off_peak_rate ? styleThousandCommas(plan.off_peak_rate) : '10'} / {planRecurrenceMap[plan?.plan_recurrence as keyof typeof planRecurrenceMap]}</p>
          </div>) : (<></>)}

          {/* Peak Rate */}
          {(plan?.plan_recurrence === "hourly" || plan?.plan_recurrence === "daily") && plan?.pricing_type === "dynamic" ? (<div className="border-0 bg-[#FAFAFA] rounded-lg p-4 shadow-sm">
            <div className="flex items-center mb-2">
              <div className={`w-2 h-2 ${peakPeriodStyles.dot} rounded-full mr-2`}></div>
              <span className="text-[#808080]/50 font-medium text-[14px] font-raleway">Peak Rate</span>
            </div>
            <p className="text-[18px] font-semibold font-raleway text-black">${plan.peak_rate ? styleThousandCommas(plan.peak_rate) : '10'} / {planRecurrenceMap[plan?.plan_recurrence as keyof typeof planRecurrenceMap]}</p>
          </div>) : (<></>)}

          {/* Max Hours */}
          {(plan?.plan_max_hours) ? (<div className="border-0 bg-[#FAFAFA] rounded-lg p-4 shadow-sm">
            <div className="flex items-center mb-2">
              <svg className="w-4 h-4 text-primaryDark-400 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
              </svg>
              <span className="text-[#808080]/50 font-medium text-[14px] font-raleway">{(["weekly", "monthly", "annual"].includes(plan.plan_recurrence as any)) ? "Max Days" : "Max Hours"}</span>
            </div>
            <p className="text-[18px] font-semibold font-raleway text-black">{(["weekly", "monthly", "annual"].includes(plan.plan_recurrence as any)) 
              ? Math.floor((plan.plan_max_hours || 0) / 24) 
              : (plan.plan_max_hours || 0)
            }</p>
          </div>) : (<></>)}

          {/* Overage */}
          {(plan?.plan_max_hours && plan?.overage_rate) ? (<div className="border-0 bg-[#FAFAFA] rounded-lg p-4 shadow-sm">
            <div className="flex items-center mb-2">
              <svg className="w-4 h-4 text-primaryDark-400 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z" clipRule="evenodd" />
              </svg>
              <span className="text-[#808080]/50 font-medium text-[14px] font-raleway">Overage</span>
            </div>
            <p className="text-[18px] font-semibold font-raleway text-black">${plan.overage_rate ? styleThousandCommas(plan.overage_rate) : '0'} / hour</p>
          </div>): (<></>)}
        </div>

        {planHasDisplayFeatures(plan.features, plan.associated_resources) && (
          <div className='mb-6'>
            <h4 className='text-[14px] font-medium text-[#808080] font-raleway mb-3'>Plan Features</h4>
            <PlanFeaturesList plan={plan} resourceDetail={resourceDetail} />
          </div>
        )}
    </>
  );
}

type MorePlanDetailsModalContentProps = {
  plan_details: ResourcePlanSchema;
  resourceDetail?: ResourceSchema;
  closeAppModal: () => void;
}

const MorePlanDetailsModalContent: React.FC<MorePlanDetailsModalContentProps> = (props) => {
  var { plan_details, resourceDetail } = props;
  // const communityId = plan_details?.community_id ? plan_details.community_id : ""

  // const { updateMembership } = useUpdateMembership(communityId)

  // const handleSwitchPlan = async () => {
  //   delete plan_details.community_id
  //   delete plan_details.category
  //   await updateMembership(plan_details as MembershipSchema)
  //   closeAppModal()
  // }

  return (
    <div className='mb-6' data-testid="more-plan-details-content">
      <h4 className='text-[14px] font-medium text-[#808080] font-raleway mb-3'>Plan Features</h4>
      <PlanFeaturesList
        plan={plan_details}
        resourceDetail={resourceDetail}
        emptyMessage="No features to show"
      />
    </div>
  );
}


type CommunityResourcesModalProps = {
  isOpen: boolean;
  communityId: string;
  closeAppModal: () => void;
}

export const CommunityResourcesModal: React.FC<CommunityResourcesModalProps> = (props) => {
  var { isOpen, communityId, closeAppModal } = props;


  const { allOptions } = useLoadResourceOptions();
  const [resourceType, setResourceType] = useState<ResourceType>("kitchen");
  const { allResources } = useLoadResources(resourceType, communityId);
  // console.log("communityResources", allResources);
  // console.log("allOptions", allOptions);

  useEffect(() => {
    // if (allOptions.length > 0) {
    //   setResourceType(allOptions[0].path as ResourceType);
    // } 
    // else {
    //   setResourceType("kitchen");
    // }
  }, [communityId, allResources, allOptions]);

  return (
    <div className={`fixed inset-0 z-50 ${isOpen ? "flex" : "hidden"} items-center justify-center`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => closeAppModal()}></div>

      <dialog
        data-testid="view-community-resources-modal"
        className="z-50 my-auto sm:w-[600px] h-auto top-10 bg-[#fff]  rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)]"
        open={isOpen}
        onClose={() => closeAppModal()}
      >
        <div className="flex flex-col h-[95px] bg-primaryDark-0 rounded-t-xl">
          <div className="flex flex-col p-4 ">
            <p className="text-[18px] font-raleway text-white font-semibold">View Resources</p>
            <div className="flex flex-row w-full">
              <p className="text-[14px] font-raleway text-white font-medium">
                Below are the {resourceType ? resourceType : ""} resources by community
              </p>
              <select 
                className="text-[14px] w-1/3 font-raleway bg-[#1A4C59]/90 rounded-md p-2 border-0 text-white font-medium ml-auto"
                value={resourceType}
                onChange={(e) => setResourceType(e.target.value as ResourceType)}
              >
                {/* <option value="all">All</option> */}
                {allOptions.map((option: SettingsOptionsType) => (
                  <option key={option.path} value={option.path}>{option.name}</option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div className="p-4">
          <CommunityResourcesList communityResources={allResources || []} resourceType={resourceType} />
        </div>
      </dialog>
    </div>
  );
}



type CommunityResourcesListProps = {
  communityResources: ResourceSchema[]
  resourceType: ResourceType
}

const CommunityResourcesList: React.FC<CommunityResourcesListProps> = ({ communityResources, resourceType }) => {
  return (
    <>
      <div className="flex flex-col gap-3">
        {(communityResources && communityResources.length > 0) ? communityResources.map((resource, i) => {
          return (
            <ResourceCard key={resource?.id ? resource?.id : i} isModal={true}  resource={resource} resourceType={resourceType} resourceIcon={CommunityIcon} toggleApplyModal={() => {}} setApplyResource={() => {}} />
          )
        }) : <div className="text-[14px] font-raleway text-[#808080]">No resources to show</div>}
      </div>
    </>
  )
}

type LoginModalProps = {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  closeAppModal: () => void;
};

export const LoginModal: React.FC<LoginModalProps> = (props) => {
  var { isOpen, setIsOpen, closeAppModal } = props;

  return (
    // <div className={`inset-0 ${isOpen ? "block" : "hidden"}`}>
    <div className={`fixed inset-0 z-50 ${isOpen ? "flex" : "hidden"} items-center justify-center`}>
    <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => closeAppModal()}></div>

      <dialog
        data-testid="view-login-modal"
        className="z-50 top-10 sm:w-[478px] h-auto bg-[#fff] p-4 rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)]"
        open={isOpen}
        onClose={() => closeAppModal()}
      >
        <Login setIsOpen={setIsOpen} />
      </dialog>
    </div>
  );
};


type FilterModalProps = {
  isOpen: boolean;
  resources?: ResourceSchema[];
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  closeAppModal: () => void;
  currentFilter: FilterType;
  // setFilterSetting: React.Dispatch<React.SetStateAction<boolean>>
  setCurrentFilter: React.Dispatch<React.SetStateAction<FilterType>>;
};

export const FilterModal: React.FC<FilterModalProps> = (props) => {
  var { isOpen, resources, closeAppModal, currentFilter, setCurrentFilter } = props;

  return (
    <div className={`fixed inset-0 z-50 ${isOpen ? "flex" : "hidden"} items-center justify-center`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => closeAppModal()}></div>

      <dialog
        data-testid="view-filter-modal"
        className="z-50 top-8 w-11/12 sm:w-[600px] max-h-[90vh] h-[710px] bg-[#fff] p-6 rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] flex flex-col"
        open={isOpen}
        onClose={() => closeAppModal()}
      >
        <FilterOptions
          resources={resources}
          currentFilter={currentFilter}
          setCurrentFilter={setCurrentFilter}
          closeFilterSetting={closeAppModal}
        />
      </dialog>
    </div>
  );
};


type MessageModalProps = {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  initialCommunityId?: string;
  onClearInitialCommunity?: () => void;
};

export const MessageModal: React.FC<MessageModalProps> = (props) => {

  const { user } = useCompleteSignIn();
  const loggedinUsername = user && user?.username ? user.username : "";
  const loggedinUid = user && user?.uid ? user.uid : "";
  var { isOpen, setIsOpen, initialCommunityId, onClearInitialCommunity } = props;
  const [choosingChat, setChoosingChat] = useState(true);
  const [selectedCommunity, setSelectedCommunity] = useState<CommunitySchema | undefined>();
  const [selectedChat, setSelectedChat] = useState<string>("chatbot");
  // let {  currentChatCommunity: selectedChat, changeChatCommunity: setSelectedChat} = useMessageState()
 const toggleChooseChat = () => {
  setChoosingChat(prev => !prev);
 }

  const resetMessageModalState = () => {
    setChoosingChat(true);
    setSelectedChat("chatbot");
    setSelectedCommunity(undefined);
    onClearInitialCommunity?.();
  };

  const closeAppModal = () => {
    setIsOpen(false);
    resetMessageModalState();
  };

  const { accountMemberships } = useLoadAccountMemberships(loggedinUid);
  const membership = accountMemberships?.find((membership: MembershipSchema) =>
    selectedChat && (membership.community_id === selectedChat || membership.id === selectedChat)
  );

  useEffect(() => {
    if (!isOpen || !initialCommunityId) {
      return;
    }

    setSelectedChat(initialCommunityId);
    setChoosingChat(false);

    const matchedMembership = accountMemberships?.find((membership: MembershipSchema) =>
      membership.community_id === initialCommunityId || membership.id === initialCommunityId
    );
    if (matchedMembership) {
      setSelectedCommunity(matchedMembership);
    }
  }, [isOpen, initialCommunityId, accountMemberships]);

  useEffect(() => {
    if (selectedChat === "chatbot" || selectedChat === "staff") {
      setSelectedCommunity(undefined);
      return;
    }

    const matchedMembership = accountMemberships?.find((membership: MembershipSchema) =>
      membership.community_id === selectedChat || membership.id === selectedChat
    );
    if (matchedMembership) {
      setSelectedCommunity(matchedMembership);
    }
  }, [selectedChat, accountMemberships]);
  // console.log("membership", membership)
  // console.log("selectedCommunity", selectedCommunity)
  // console.log("accountMemberships", accountMemberships)
  return (
    <div className={`inset-0 ${isOpen ? "block" : "hidden"} fixed right-0 z-[9999]`}>
      <div className="fixed inset-0  z-[9998]" onClick={() => closeAppModal()}></div>
      <dialog
        data-testid="view-kitchen-modal"
        // className="z-50 top-20 sm:w-[478px] h-auto bg-[#fff] p-4 rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)]"
        className="fixed z-[9999] bottom-32 w-[438px] h-auto md:mr-10 rounded-[16px] shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)]"
        open={isOpen}
        onClose={() => closeAppModal()}
      >
        <div className="bg-primaryDark-0 h-[60px] w-full rounded-t-[16px] py-5 px-3 flex flex-row gap-2">
          {!choosingChat ? <ArrowLeft className="h-[24px] w-[24px] hover:cursor-pointer text-white/70 my-auto" onClick={() => toggleChooseChat()}/> : ""}
          <div 
            onClick={() => choosingChat ? setIsOpen(false) : null} 
            className="text-white w-full text-lg font-bold mt-[1px] font-raleway hover:cursor-pointer flex flex-row items-center"
          >
            {!choosingChat && selectedChat === "chatbot" && (
              <ChatbotInverted className="h-[24px] w-[24px] flex-shrink-0 text-primaryDark-0/90 mr-2" />
            )}
            {!choosingChat && selectedChat === "staff" && (
              <StaffIconInverted className="h-[24px] w-[24px] flex-shrink-0 text-primaryDark-0/90 mr-2" />
            )}
            {!choosingChat && selectedChat !== "chatbot" && selectedChat !== "staff" && membership?.logo && (
              // <img
              //   src={membership.logo}
              //   alt={membership.name || "Community"}
              //   className="h-[24px] w-[24px] bg-white rounded-lg object-contain mr-2 flex-shrink-0"
              // />
              <span className="mr-2 flex-shrink-0">
                <CommunityAvatar logo={membership.logo} label={membership.name} size="sm" />
              </span>
            )}
            <span className="truncate flex-shrink-0">
              {choosingChat
                ? <span className="flex-shrink-0 mx-2">How Can We Assist You?</span>
                : selectedChat === "chatbot"
                  ? <span className="flex-shrink-0">AI Assistant</span>
                  : <span className="flex-shrink-0">{membership?.name || "HomeCook"}</span>}
            </span>
          </div>
        </div>
        <div>
          {choosingChat ? (
            <div className={`  w-auto  bg-[#fff] rounded-md`}>
              <UserListWindow 
                username={loggedinUsername} 
                setSelectedCommunity={setSelectedCommunity} 
                selectedCommunity={selectedCommunity} 
                choosingChat={choosingChat} 
                setChoosingChat={() => toggleChooseChat()} 
                selectedChat={selectedChat} 
                setSelectedChat={setSelectedChat} 
                accountMemberships={accountMemberships || []} 
              />
            </div>
          ) : (
            <div>
              <ChatWindow currentChatCommunity={selectedChat} username={loggedinUsername} selectedCommunity={selectedCommunity ?? membership}/>
            </div>
          )}
        </div>
      </dialog>
    </div>
  );
};


type AddCredentialModalProps = {
  isOpen: boolean;
  requirement: CurrentRequirementsSchema
  closeAppModal: () => void;
  handleSubmitCredential: (credential: CredentialSchema, communityId: string) => void
}

export const AddCredentialModal: React.FC<AddCredentialModalProps> = (props) => {
  var { isOpen, requirement, handleSubmitCredential, closeAppModal } = props

  return (
    <div className={`fixed inset-0 z-[100] ${isOpen ? "flex" : "hidden"} items-start justify-center`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-[99]" onClick={() => closeAppModal()} ></div>
      <dialog
        data-testid="add-credential-modal"
        className="z-[100] top-20 relative w-10/12 sm:w-[478px] h-auto bg-[#fff] p-4 rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)]"
        open={isOpen}
        onClose={() => closeAppModal()}
        style={{ margin: 0 }}
      >
        <AddCredentialForm requirement={requirement} handleSubmitCredential={handleSubmitCredential} handleClose={closeAppModal} />
      </dialog>
    </div>
  );
}





type ApplyFundingModalProps = {
  isOpen: boolean;
  resourceDetail: ResourceSchema
  closeAppModal: () => void;
  handleSubmitRequest: (resource: ResourceSchema, resourceType: ResourceType, booking: ResourceBookingSchema) => Promise<boolean>
}

export const ApplyFundingModal: React.FC<ApplyFundingModalProps> = (props) => {
  var { isOpen, handleSubmitRequest, closeAppModal, resourceDetail } = props

  return (
    <div className={`fixed inset-0 z-[100] ${isOpen ? "flex" : "hidden"} items-start justify-center pt-0`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-[99]" onClick={() => closeAppModal()} ></div>
      <dialog
        data-testid="book-funding-modal"
        className="z-[100] relative top-0 w-auto sm:w-[810px] h-auto bg-[#fff] p-4 rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)]"
        open={isOpen}
        onClose={() => closeAppModal()}
      >
        <ApplyFundingForm resourceDetail={resourceDetail} handleSubmitRequest={handleSubmitRequest} handleClose={closeAppModal} />
      </dialog>
    </div>
  );
}

type RequestMembershipModalProps = {
  // isOpen: boolean;
  formType: "request" | "manage" | null;
  resourceDetail: ResourceSchema
  selectedPlan?: PlanSchema | null
  // handleSubmitRequest: (resource: ResourceSchema, resourceType: ResourceType, booking: ResourceBookingSchema) => Promise<boolean>
  closeAppModal: () => void;
}


export const RequestMembershipModal: React.FC<RequestMembershipModalProps> = (props) => {
  var { closeAppModal, resourceDetail, formType, selectedPlan } = props
  const communityId = resourceDetail?.community_id ? resourceDetail?.community_id : ""
  const { currentMember, reloadCurrentMember } = useLoadMember(communityId)
  // const navigate = useNavigate()
  useEffect(() => {
    reloadCurrentMember()
  }, [reloadCurrentMember, currentMember])

  return (
    <div className={`fixed inset-0 z-50 ${(formType !== null) ? "flex" : "hidden"} items-start justify-center py-4`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => closeAppModal()}></div>
      <dialog
        data-testid="add-plan-modal"
        className="z-50 w-full max-w-lg md:max-w-2xl  bg-[#fff] relative rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] overflow-hidden flex flex-col"
        open={formType !== null}
        onClose={() => closeAppModal()}
        style={{ margin: 0 }}
      >
        <div className="overflow-y-auto max-h-[100vh] flex-1 pb-4">
          {/* <div className="h-[40px] w-full bg-gray-100">
            <span onClick={closeAppModal} className="ml-auto w-full flex cursor-pointer">
                <Cancel className="text-[#A1A1A1] hover:text-[#777] h-[18px] w-[18px] ml-auto" />
            </span>
          </div> */}
          <RequestMembershipForm currentMember={currentMember || null} formType={formType} resourceDetail={resourceDetail} selectedPlan={selectedPlan} handleClose={closeAppModal} />
        </div>
      </dialog>
    </div>
  );

}


type RequestKitchenModalProps = {
  isOpen: boolean;
  resourceDetail: ResourceSchema
  selectedPlan?: ResourcePlanSchema
  inventoryOnlyItem?: InventorySchema
  handleSubmitRequest: (resource: ResourceSchema, resourceType: ResourceType, booking: ResourceBookingSchema) => Promise<boolean>
  handleSubmitMultipleRequest: (resource: ResourceSchema, resourceType: ResourceType, bookings: ResourceBookingSchema[]) => Promise<boolean>
  closeAppModal: () => void;
}

export const RequestKitchenModal: React.FC<RequestKitchenModalProps> = (props) => {
  var { isOpen, selectedPlan, inventoryOnlyItem, handleSubmitRequest, handleSubmitMultipleRequest, closeAppModal, resourceDetail } = props
  // const communityId = resourceDetail?.community_id ? resourceDetail?.community_id : "resource_pantry"
  const communityId = resourceDetail?.community_id ? resourceDetail?.community_id : ""
  const { currentMember, reloadCurrentMember } = useLoadMember(communityId)
  const navigate = useNavigate()
  useEffect(() => {
    reloadCurrentMember()
  }, [reloadCurrentMember, currentMember])

  return (
    <div className={`fixed inset-0 z-50 ${isOpen ? "flex" : "hidden"} items-start justify-center py-4`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => closeAppModal()}></div>
      <dialog
        data-testid="add-plan-modal"
        className="z-50 w-full sm:w-5/12 h-auto bg-[#fff] relative rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] overflow-hidden flex flex-col"
        open={isOpen}
        onClose={() => closeAppModal()}
        style={{ margin: 0 }}
      >
        <div className="overflow-y-auto max-h-[100vh] flex-1 p-4">
          {
            (currentMember && currentMember?.status) ? (
              (['approved', 'verified', 'active'].includes(currentMember?.status as MembershipStatusType)) ? (
                <RequestKitchen key={inventoryOnlyItem?.id ?? 'full-kitchen-booking'} currentMember={currentMember} selectedPlan={selectedPlan || {} as ResourcePlanSchema} resourceDetail={resourceDetail} inventoryOnlyItem={inventoryOnlyItem} handleSubmitRequest={handleSubmitRequest} handleSubmitMultipleRequest={handleSubmitMultipleRequest} handleClose={closeAppModal} setIsSubmitting={() => null} />
              ) : (
                <span className="flex flex-col justify-evenly">
                  {/* <img src={resourceDetail?.logo ? resourceDetail.logo : "/logo192.png"} alt="homecook-logo" className="h-[60px] self-center rounded-lg"/> */}
                  <InlineStatusSkeleton variant="desktop" />
                  <p className="text-primaryDark-0 font-raleway text-[24px] text-center my-2">
                    <b>{resourceDetail.name} </b>Membership is {capitalizeString(currentMember?.status)}
                  </p>

                  <p className='text-primaryDark-300 hover:text-primaryDark-200 cursor-pointer mx-auto my-4' onClick={() => navigate(`/profile/memberships?id=${currentMember?.community_id}`)}>View Next Steps</p>
                </span>
              )
            ) : (
              <></>
            )
          }
        </div>
      </dialog>
    </div>
  );

}


type OrderInventoryModalProps = {
  isOpen: boolean;
  resourceDetail: ResourceSchema
  handleSubmitRequest: (resource: ResourceSchema, resourceType: ResourceType, booking: ResourceBookingSchema) => Promise<boolean>
  closeAppModal: () => void;
}

export const OrderInventoryModal: React.FC<OrderInventoryModalProps> = (props) => {
  var { isOpen, handleSubmitRequest, closeAppModal, resourceDetail } = props
  return (
    <div className={`fixed inset-0 z-[100] ${isOpen ? "flex" : "hidden"} items-start justify-center pt-0`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-[99]" onClick={() => closeAppModal()} ></div>
      <dialog
        data-testid="book-inventory-modal"
        className="z-[100] relative top-0 w-auto sm:w-[810px] h-auto bg-[#fff] p-4 rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)]"
        open={isOpen}
        onClose={() => closeAppModal()}
      >
        <OrderInventoryForm resourceDetail={resourceDetail} handleSubmitRequest={handleSubmitRequest} handleClose={closeAppModal} />
      </dialog>
    </div>
  );
}

type RegisterTrainingModalProps = {
  isOpen: boolean;
  resourceDetail: ResourceSchema
  handleSubmitRequest: (resource: ResourceSchema, resourceType: ResourceType, booking: ResourceBookingSchema) => Promise<boolean>
  closeAppModal: () => void;
}

export const RegisterTrainingModal: React.FC<RegisterTrainingModalProps> = (props) => {
  var { isOpen, handleSubmitRequest, closeAppModal, resourceDetail } = props
  return (
    <div className={`fixed inset-0 z-[100] ${isOpen ? "flex" : "hidden"} items-start justify-center pt-0`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-[99]" onClick={() => closeAppModal()} ></div>
      <dialog
        data-testid="book-training-modal"
        className="z-[100] relative top-0 w-auto sm:w-[810px] h-auto bg-[#fff] p-4 rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)]"
        open={isOpen}
        onClose={() => closeAppModal()}
      >
        <RegisterTrainingForm resourceDetail={resourceDetail} handleSubmitRequest={handleSubmitRequest} handleClose={closeAppModal} />
      </dialog>
    </div>
  );
}


type ScheduleExpertModalProps = {
  isOpen: boolean;
  resourceDetail: ResourceSchema
  handleSubmitRequest: (resource: ResourceSchema, resourceType: ResourceType, booking: ResourceBookingSchema) => Promise<boolean>
  closeAppModal: () => void;
}

export const ScheduleExpertModal: React.FC<ScheduleExpertModalProps> = (props) => {
  var { isOpen, handleSubmitRequest, closeAppModal, resourceDetail } = props
  return (
    <div className={`fixed inset-0 z-[100] ${isOpen ? "flex" : "hidden"} items-start justify-center pt-0`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-[99]" onClick={() => closeAppModal()} ></div>
      <dialog
        data-testid="book-expert-modal"
        className="z-[100] relative top-0 w-auto sm:w-[810px] h-auto bg-[#fff] p-4 rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)]"
        open={isOpen}
        onClose={() => closeAppModal()}
      >
        <ScheduleExpertForm resourceDetail={resourceDetail} handleSubmitRequest={handleSubmitRequest} handleClose={closeAppModal} />
      </dialog>
    </div>
  );
}


type ObtainDocumentationModalProps = {
  isOpen: boolean;
  resourceDetail: ResourceSchema
  handleSubmitRequest: (resource: ResourceSchema, resourceType: ResourceType, booking: ResourceBookingSchema) => Promise<boolean>
  closeAppModal: () => void;
}

export const ObtainDocumentationModal: React.FC<ObtainDocumentationModalProps> = (props) => {
  var { isOpen, handleSubmitRequest, closeAppModal, resourceDetail } = props
  return (
    <div className={`fixed inset-0 z-[100] ${isOpen ? "flex" : "hidden"} items-start justify-center pt-0`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-[99]" onClick={() => closeAppModal()} ></div>
      <dialog
        data-testid="book-documentation-modal"
        className="z-[100] relative top-0 w-auto sm:w-[810px] h-auto bg-[#fff] p-4 rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)]"
        open={isOpen}
        onClose={() => closeAppModal()}
      >
        <ObtainDocumentationForm resourceDetail={resourceDetail} handleSubmitRequest={handleSubmitRequest} handleClose={closeAppModal} />
      </dialog>
    </div>
  );
}

type FocusGroupSuccessModalProps = {
  isOpen: boolean;
  communityId?: string;
  closeAppModal: () => void;
}

export const FocusGroupSuccessModal: React.FC<FocusGroupSuccessModalProps> = (props) => {
  var { isOpen, communityId, closeAppModal } = props
  const navigate = useNavigate();
  return (
    <div className={`inset-0 ${isOpen ? "block" : "hidden"}`}>
      <div className="fixed inset-0 bg-white opacity-90" onClick={() => closeAppModal()} ></div>
      <dialog
        data-testid="complete-step-success-modal"
        className="z-50 top-20 w-auto sm:w-[478px] h-auto sm:h-[300px] bg-[#fff] p-4 rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)]"
        open={isOpen}
        onClose={() => closeAppModal()}
      > 
        <CompleteStepSuccess communityId={communityId} onGoToProfile={() => navigate("/profile")} />
      </dialog>
    </div>
  );
} 



type DreamStageModalProps = {
  isOpen: boolean;
  showIntro: boolean;
  setShowIntro: React.Dispatch<React.SetStateAction<boolean>>;
  handleSubmitForm: (data: BusinessFormData) => void;
  closeAppModal: () => void;
  editingBusiness: MyBusinessSchema | null;
}

export const DreamStageModal: React.FC<DreamStageModalProps> = (props) => {
  var { isOpen, closeAppModal, showIntro, setShowIntro, handleSubmitForm, editingBusiness } = props

  useEffect(() => {
    // console.log(editingBusiness)
  }, [editingBusiness])
  
  return (
    <div className={`inset-0 ${isOpen ? "block" : "hidden"}`}>
      <div className="fixed inset-0 bg-white opacity-90" onClick={() => closeAppModal()} ></div>
      <dialog
        data-testid="add-business-modal"
        className="fixed z-50 top-20 w-auto sm:w-[600px] h-auto bg-[#fff] p-4 rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)]"
        open={isOpen}
        onClose={() => closeAppModal()}
      > 
        <AddBusiness 
          handleSubmitForm={handleSubmitForm} 
          handleClose={() => closeAppModal()} 
          showIntro={showIntro} 
          setShowIntro={setShowIntro}
          editingBusiness={editingBusiness}
        />
      </dialog>
    </div>
  );
} 

type GetAIModalProps = {
  isOpen: boolean;
  prompt: string;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setDreamModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const GetAIModal: React.FC<GetAIModalProps> = (props) => {
  var { isOpen, setIsOpen } = props
  return (
    <div className={`inset-0 ${isOpen ? "block" : "hidden"}`}>
      <div className="fixed inset-0 bg-white opacity-90" onClick={() => setIsOpen(false)} ></div>
      <dialog
        data-testid="get-ai-modal"
        className="fixed z-50 top-20 w-auto sm:w-[600px] h-auto bg-[#fff] p-4 rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)]"
        open={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <GenAIView {...props} />
      </dialog>
    </div>
  );
}

export { InviteTeamMemberModal } from "../../components/InviteTeamMemberModal";
